<nz-card class="flow-card" nzTitle="Dish Credit Check">
  <p class="flow-card__subtitle">Verify credit in seconds so you can lock in promo pricing with confidence.</p>

  <form nz-form [formGroup]="qualForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
    <nz-form-item class="flow-form__item" *ngIf="!notQualified && !customerType">
      <nz-form-control>
        <label nz-checkbox formControlName="qualCheck">
          Perform credit check?
        </label>
      </nz-form-control>
    </nz-form-item>

    <ng-container *ngIf="qualForm.get('qualCheck')?.value">
      <nz-form-item class="flow-form__item">
        <nz-form-label [nzRequired]="true" nzFor="ssn">SSN</nz-form-label>
        <nz-form-control>
          <input
            nz-input
            id="ssn"
            type="password"
            inputmode="numeric"
            maxlength="9"
            minlength="4"
            formControlName="ssn"
            [disabled]="notQualified || customerType"
            placeholder="Full 9 or last 4 required"
          />
        </nz-form-control>
      </nz-form-item>

      <div class="flow-actions" *ngIf="!notQualified && !customerType">
        <button
          nz-button
          nzType="primary"
          nzBlock
          [disabled]="qualForm.invalid"
          (click)="qualifyFn()"
          [nzLoading]="loading"
        >
          Qualify Lead
        </button>
      </div>

      <div class="status-stack" *ngIf="notQualified || customerType || qualifiedPromotion">
        <nz-alert *ngIf="notQualified" nzType="error" [nzMessage]="notQualified" nzShowIcon></nz-alert>
        <nz-alert *ngIf="customerType" nzType="success" [nzMessage]="customerType" nzShowIcon></nz-alert>
        <nz-alert *ngIf="qualifiedPromotion" nzType="info" [nzMessage]="'Qualified promotion: ' + qualifiedPromotion" nzShowIcon></nz-alert>
      </div>

      <div class="flow-actions" *ngIf="needVerify && !failedVerify">
        <button
          nz-button
          nzType="default"
          nzBlock
          [disabled]="qualForm.invalid"
          (click)="handleIDVerify()"
          [nzLoading]="verifyLoading"
        >
          Start Identity Questions
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="!qualForm.get('qualCheck')?.value">
      <nz-card nzType="inner" class="flow-card__inner">
        <h3>Need credit approval?</h3>
        <p>Switch on the credit check to send a quick SSN verification before installing.</p>
      </nz-card>
    </ng-container>

    <div class="flow-actions flow-actions--trailing">
      <button
        nz-button
        nzType="primary"
        nzBlock
        [disabled]="!customerType"
        (click)="continue()"
        [nzLoading]="continueLoading"
      >
        Next Step
      </button>
    </div>
  </form>
</nz-card>

<nz-modal
  [(nzVisible)]="verifyModal"
  nzTitle="ID Verify Questions"
  [nzFooter]="modalFooter"
  (nzOnCancel)="cancel()"
>
  <ng-container *nzModalContent>
    <form [formGroup]="verifyForm" class="verify-form">
      <div formArrayName="selections">
        <div *ngFor="let question of questions; let i = index; trackBy: trackByIndex" class="verify-question">
          <div class="verify-question__title">
            {{ question.QuestionNumber }} — {{ question.QuestionText }}
          </div>
          <nz-radio-group [formControlName]="i" class="verify-question__answers">
            <label
              nz-radio
              nzBlock
              *ngFor="let answer of question.AnswerChoice"
              [nzValue]="answer.AnswerNumber"
              class="verify-question__option"
            >
              {{ answer.AnswerText }}
            </label>
          </nz-radio-group>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button (click)="cancel()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!verifyForm.valid"
      (click)="submitQuestions()"
    >
      Submit
    </button>
  </ng-template>
</nz-modal>
